import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en/identification.json";
import enBase from "@cleverbase-trust-drivers/shared/locales/en/base.json";
import nl from "./locales/nl/identification.json";
import nlBase from "@cleverbase-trust-drivers/shared/locales/nl/base.json";

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: "nl",
    resources: {
      en: {
        identification: en,
        base: enBase,
      },
      nl: {
        identification: nl,
        base: nlBase,
      },
    },
  });

export default i18next;
